
import RestService from '../services/rest';

async function getAllSettings() {
	return RestService.getAuthenticated('utils/public-settings');
}

export default {
	getAllSettings,
};